import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-curve-bottom-hero",
  "use": "icon-curve-bottom-hero-usage",
  "viewBox": "0 0 300 15.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 300 15.8\" id=\"icon-curve-bottom-hero\">\r\n<title>curve-bottom</title>\r\n<path d=\"M0,0c48.8,10.5,101.4,15.8,154.5,15.5C204.6,15.2,254,9.9,300,0v15.8H0V0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol